import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  table: {
    width: '100%'
  },
  textField: {
    width: '100%'
  }
}));
